import Service from '@/services/abstract/service'

export default class Supervisor extends Service {
  constructor() {
    super()
    this._equipeRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas/${this._empresaPrincipal}/Equipes`
    )
    this._rankRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Rank`
    )
    this._leadRef = this._db.collection(`${this._prefix}-leads`)
  }

  async selectEquipes(cpfSupervisor) {
    try {
      this._loading.setLoading(true, 'Carregando Equipes')
      const response = await this._equipeRef
        .where('supervisor', '==', cpfSupervisor)
        .get()

      let equipes = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          equipes.push(doc.data())
        }
      }

      return Promise.resolve(equipes)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getRanks() {
    try {
      this._loading.setLoading(true, 'Carregando Rank')

      const dateStart = new Date()
      dateStart.setDate(1)
      const date = new Date()
      date.setMonth(date.getMonth() + 1, 0)
      const dateEnd = date

      const response = await this._rankRef
        .where('dataUltimaAtualizacao', '>=', dateStart)
        .where('dataUltimaAtualizacao', '<=', dateEnd)
        .get()

      let rank = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          rank.push(doc.data())
        }
      }

      return Promise.resolve(rank)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  separar(base, maximo) {
    let resultado = [[]]
    let grupo = 0

    for (let i = 0; i < base.length; i++) {
      resultado[grupo].push(base[i].cpf_completo)
      if (resultado[grupo].length === maximo) {
        grupo++
        resultado.push([])
      }
    }

    return resultado
  }

  async getLeadsByEquipe(dateStart, dateEnd, equipe) {
    try {
      this._loading.setLoading(true, 'Carregando Leads da Equipe')
      let result = this.separar(equipe, 10)

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      let leads = new Array()
      for (const arrayCpfColaboradores of result) {
        let response = await this._leadRef
          .where('donoDoLead', 'in', arrayCpfColaboradores)
          .where('dataCriacao', '>=', dataInicio)
          .where('dataCriacao', '<=', dataFim)
          .get()
        if (!response.empty) {
          for (let doc of response.docs) {
            leads.push(doc.data())
          }
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getHistoricoRanksByEquipe(equipe) {
    try {
      this._loading.setLoading(true, 'Carregando Historico do Rank')
      let result = this.separar(equipe, 10)

      let dateStart = new Date()
      dateStart.setMonth(dateStart.getMonth() - 6)
      let dateEnd = new Date()

      let ranks = new Array()
      for (const arrayCpfColaboradores of result) {
        let response = await this._rankRef
          .where('cpf', 'in', arrayCpfColaboradores)
          .where('dataUltimaAtualizacao', '>=', dateStart)
          .where('dataUltimaAtualizacao', '<=', dateEnd)
          .orderBy('dataUltimaAtualizacao', 'desc')
          .get()

        if (!response.empty) {
          for (let doc of response.docs) {
            ranks.push(doc.data())
          }
        }
      }

      return Promise.resolve(ranks)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
